import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import meter from './modules/meter'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		cometRooms: [],

		cometConnect: false,
		cometEventReload: null,
		cometEventUpdate: null
	},
	mutations: {
		cometRooms: (state, rooms) => {
			state.cometRooms = rooms
		},

		SOCKET_CONNECT: (state) => {
			state.cometConnect = true
		},
		SOCKET_RELOAD: (state, message) => {
			state.cometEventReload = message
		},
		SOCKET_UPDATE: (state, message) => {
			state.cometEventUpdate = message
		}
	},
	actions: {
		socket_connect: (context) => {
			var vue = new Vue()
			for (var i in context.state.cometRooms) {
				vue.$socket.emit('join', context.state.cometRooms[i])
			}
		}
	},
	modules: {
		app,
		user,
		meter
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js